/**
 * OPL Management page - container with tab navigation (Overview / Issue List).
 */

import { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { Tabs, Typography } from 'antd';
import { useConfigStore } from '@/store/configStore';
import OplOverview from './OplOverview';
import OplIssueList from './OplIssueList';
import { CopyExternalLinkButton } from '@/components/packages/CopyExternalLinkButton';

const { Title } = Typography;

const OplManagement = () => {
  const { projectId } = useParams<{ projectId: string }>();
  const [searchParams] = useSearchParams();
  const { projects } = useConfigStore();

  const initialIssueId = searchParams.get('issueId');
  const [activeTab, setActiveTab] = useState(initialIssueId ? 'issues' : 'overview');

  const numericProjectId = Number(projectId);
  const project = projects.find((p) => p.id === numericProjectId);

  useEffect(() => {
    const projectName = project?.name;
    if (!projectName) return;
    const suffix = initialIssueId ? `${initialIssueId} - ` : '';
    document.title = `${projectName} - ${suffix}OPL - BSP Package Delivery`;
    return () => {
      document.title = 'BSP Package Delivery - 底软包交付管理系统';
    };
  }, [project?.name, initialIssueId]);

  const handleNavigateToIssue = (_issueId: number) => {
    setActiveTab('issues');
  };

  return (
    <div>
      {/* margin:0 是为了让标题与复制按钮垂直居中对齐，原标题的下边距挪到容器上 */}
      <div className="flex items-center gap-1" style={{ marginBottom: '0.5em' }}>
        <Title level={4} style={{ margin: 0 }}>
          {project?.name || '项目'} - OPL问题管理
        </Title>
        <CopyExternalLinkButton kind="current" />
      </div>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'overview',
            label: '总览',
            children: (
              <OplOverview
                projectId={numericProjectId}
                onNavigateToIssue={handleNavigateToIssue}
              />
            ),
          },
          {
            key: 'issues',
            label: '问题列表',
            children: (
              <OplIssueList
                projectId={numericProjectId}
                initialIssueId={initialIssueId ?? undefined}
              />
            ),
          },
        ]}
      />
    </div>
  );
};

export default OplManagement;
